import React, { useEffect, useState } from "react";
import { message, Spin, Button } from "antd";
import styles from "./BusinessChart.less";
import BaseChart from "../baseChart/BaseChart.tsx";
import { ReloadOutlined } from "@ant-design/icons";
import HttpTool from "../../../../tool/HttpTool";
import APILXD from "../../../../http/APILXD";

type Props = {
  pageParams: any;
  loading?: boolean;
}

const SplitTag = "_#_#_"

export default function(props:Props) {
  const [loading, setLoading] = useState(props.loading || false);
  const [chartConfig, setChartConfig] = useState({
    xAxis: {
      name: "",
      type: 'category',
      nameLocation: "center",
      nameGap: 25,
      axisLabel: {
        interval: 0,
        rotate: -45,
      },
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      axisLabel: {
        formatter: `{value}台`
      }
    },
    tooltip: {
      trigger: 'item',
      axisPointer: {
        type: 'shadow'
      },
      formatter: (params,ticket)=>{
        // console.log(params);
        return `<div>
                     <div>${params.marker}执行单元：${params.seriesName?.split(SplitTag)?.[1]}</div>
                     <div>所属空间：${params.name}</div>
                     <div>设备数量：${params.data[params.seriesName]}台/${params.seriesName?.split(SplitTag)[2]}台</div>
                </div>`
      }
      // formatter: ()=>{
      //   return <div>123</div>;
      // }
    },
    legend: {show: false}
  });

  useEffect(() => {
    getData();
  }, [props.pageParams]);

  const getData= ()=>{

    setLoading(true)

    HttpTool.post(APILXD.businessSpaceStatistics, (code: any, msg: any, data: any) => {
      let unitData = [];
      let spaceData = data?.map((eachSpace)=>{
        let obj = {
          name: eachSpace.spaceName,
        }
        eachSpace.execUnitStat?.map((eachUnit)=>{
          let uid = eachUnit.execUnitId + SplitTag + eachUnit.execUnitName + SplitTag + eachSpace.deviceCount;
          unitData.push({
            type: "bar",
            uid: uid,
            stack: 'total',
          })
          obj[uid] = eachUnit.deviceCount;
        })

        return obj
      })


      setChartConfig((oldConfig)=>{
        let newConfig = {...oldConfig}
        newConfig.dataset = {
          dimensions: ["name"].concat(unitData.map((a)=>{return a.uid})),
          source: spaceData,
        }
        newConfig.series = unitData;

        console.log(newConfig)
        return newConfig;
      })

      setLoading(false)
    }, (code: any, msg: any) => {
      message.error(msg);
      setLoading(false)
    },  {
      ...props.pageParams
    });
  }

  return <Spin wrapperClassName={styles.spinBoxStyle} spinning={loading}>
    <div className={styles.itemBox}>
      <div className={styles.title}>
        <Button
          type={'link'}
          icon={<ReloadOutlined />}
          onClick={() => {
            getData();
          }}
        />
        执行单元统计
      </div>
      <BaseChart
        chartType={"bar"}
        chartConfig={chartConfig}
      />
    </div>
  </Spin>;
}
